"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatureType = exports.CreatureStateType = void 0;
/**
 * The state type of the current creature
 */
var CreatureStateType;
(function (CreatureStateType) {
    CreatureStateType["Idle"] = "idle";
    CreatureStateType["Walk"] = "walk";
    CreatureStateType["Jump"] = "jump";
    CreatureStateType["Death"] = "death";
    CreatureStateType["NormalAttack"] = "normalAttack";
})(CreatureStateType || (exports.CreatureStateType = CreatureStateType = {}));
var CreatureType;
(function (CreatureType) {
    CreatureType["Character"] = "character";
    CreatureType["Player"] = "player";
    CreatureType["Goblin"] = "goblin";
})(CreatureType || (exports.CreatureType = CreatureType = {}));
